import {React, useState, useContext, useEffect } from 'react'
import BannerBuilder from './containers/bannerBuilder/BannerBuilder.js'
import './App.css'
import Navbar from './containers/navbar/Navbar.js'
import { Footer } from './containers/footer/footer.js'
import { CanvasContext } from './helpers/context/Context.js'
import { InitControls } from './helpers/InitControls';

const App = () => {
  const [canvas, setCanvas] = useState('');
const [IsPageEnabled, setIsPageEnabled] = useState(true);



// Define the init function
function init() {
  // Your initialization code
  console.log('App initialized');

  const initCanvas = () => (
      new fabric.Canvas('canvas', {
      height: 500,
      width: 1500,
      backgroundColor: 'white',
      preserveObjectStacking: true
      })
  );

  if(!canvas){
    setCanvas(initCanvas());
    InitControls();
  }
  document.getElementsByClassName("upper-canvas")[0].style.pointerEvents = "all";

  setIsPageEnabled(true);
  document.documentElement.setAttribute("data-disabled", false);
}

// Use useEffect to call the init method when the component mounts
useEffect(() => {
  init();
  // If you have a Load method to change status to connected, call it here as well
  // Load();
}, []); // The empty array [] means this effect will only run once, after the initial render


  return (
    <div className='App'>
      <CanvasContext.Provider value={{canvas, setCanvas, IsPageEnabled, setIsPageEnabled}}>
        <Navbar/>
        <div className='content'>
          <BannerBuilder/>
        </div>
        <Footer/>
      </CanvasContext.Provider>
    </div>
  )
}

export default App